import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CoreButtonComponent } from '../core-button/core-button.component';

import { AppIcons } from '@core/utilities/icons';

@Component({
    selector: 'app-core-modal',
    standalone: true,
    imports: [
      CommonModule,
      FontAwesomeModule,
      CoreButtonComponent],
    templateUrl: './core-modal.component.html',
    styleUrl: './core-modal.component.scss'
})
export class CoreModalComponent {
    @Input() isOpen: boolean = false;
    @Input() title: string = '';
    @Input() showFooter: boolean = true;
    @Input() contentScrollable: boolean = true;
    @Input() closeOnBackdrop: boolean = false;
    @Input() closeOnEsc: boolean = false;
    @Input() isAlert: boolean = false;

    @Output() close = new EventEmitter<void>();

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
      if (this.isOpen && event.key === 'Escape') {
        if (this.closeOnEsc) {
          this.onClose();
        } else {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }

    icons: typeof AppIcons = AppIcons;

    onOverlayClick() {
      if (this.closeOnBackdrop) {
        this.onClose();
      }
    }

    onClose() {
        this.close.emit();
    }

    // Prevent closing when clicking inside content
    stopProp(event: Event) {
        event.stopPropagation();
    }
}
